'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlChart", function (scopeUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div class="tl-chart">' + '   <highchart config="chartConfig"></highchart>' + '</div>',
    link: function link($scope, $element, $attrs, ctrl) {
      var unwatch = null;
      $attrs.$observe("chartConfig", function (configAttrName) {
        unwatch && unwatch();
        scopeUtils.dataBind(configAttrName, "chartConfig", $scope);
      });
      $scope.$on("$print:toggle", function (evt, print) {
        var highchartCtrl = ctrl.getHighchartCtrl();
        highchartCtrl.redraw();
      });
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        highchartCtrl = null;
      ctrl.getHighchartCtrl = function () {
        if (highchartCtrl == null) {
          highchartCtrl = $element.find("div.highchart").controller("highchart");
        }
        return highchartCtrl;
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tl-chart.js
// module id = 3015
// module chunks = 13